@if (calendarConnectEnabled$ | async) {
  <div class="google-calendar">
    @if (isEntitledTier$ | async) {
      <div class="meeting-agent-section">
        <div class="meeting-agent-intro">
          <terra-icon class="meeting-agent-intro-icon" icon="sparkle" variant="fill" size="20" />
          <div class="meeting-agent-intro-copy">
            <p class="meeting-agent-intro-title">
              Let Ninety take the notes <ninety-chip color="brand" size="small">Beta</ninety-chip>
            </p>
            <p class="text-light meeting-agent-intro-subtext">
              Maz joins your call, captures your discussion, and delivers a summary you can review, share, or turn into
              To-dos.
            </p>
          </div>
        </div>
        <div class="add-meeting-agent-row">
          <terra-switch
            class="add-meeting-agent-toggle"
            [attr.data-cy]="dataCyPrefix() + '_add-meeting-agent-toggle'"
            [formControl]="addMeetingAgentControl()">
            Record and transcribe this meeting
          </terra-switch>
          <p class="text-light add-meeting-agent-subtext">
            Maz joins this call as a visible participant and records it. Everyone on the invite will see it.
          </p>
        </div>
        @if (addMeetingAgentControl().value) {
          <div class="meeting-link-row">
            @if (calendarStatusLoading()) {
              <ninety-skeleton
                [theme]="{ height: '36px', width: '100%', 'border-radius': '4px', 'margin-bottom': '0' }"
                [attr.data-cy]="dataCyPrefix() + '_calendar-status-loading'" />
            } @else {
              @if (!isCalendarConnected()) {
                <ninety-button
                  filled
                  primary
                  class="full-width"
                  [disabled]="connectingCalendar()"
                  (click)="connectCalendar()"
                  [attr.data-cy]="dataCyPrefix() + '_calendar-button'">
                  <terra-icon icon="calendar" size="20" />
                  {{ connectingCalendar() ? 'Connecting...' : 'Connect my calendar' }}
                </ninety-button>
              } @else if (pickedEvent(); as event) {
                <div class="calendar-event-selected" [attr.data-cy]="dataCyPrefix() + '_calendar-event-selected'">
                  <div class="calendar-event-selected-info">
                    <span class="calendar-event-selected-title">{{ event.summary }}</span>
                    <div class="calendar-event-selected-meta">
                      @if (event.start) {
                        <span class="text-light calendar-event-selected-date">
                          {{ event.start | date: 'MMM d, y h:mm a' }}
                        </span>
                      }
                    </div>
                  </div>
                  <button
                    type="button"
                    class="change-event-button"
                    (click)="openPicker.emit()"
                    [attr.data-cy]="dataCyPrefix() + '_change-event-button'">
                    Change event
                  </button>
                </div>
              } @else if (existingMeetingLink()) {
                <div class="calendar-event-selected" [attr.data-cy]="dataCyPrefix() + '_current-link'">
                  <div class="calendar-event-selected-info">
                    <span class="calendar-event-selected-title">{{ existingMeetingLink() }}</span>
                  </div>
                  <button
                    type="button"
                    class="change-event-button"
                    (click)="openPicker.emit()"
                    [attr.data-cy]="dataCyPrefix() + '_change-event-button'">
                    Change event
                  </button>
                </div>
              } @else {
                <ninety-button
                  filled
                  primary
                  class="full-width"
                  (click)="openPicker.emit()"
                  [attr.data-cy]="dataCyPrefix() + '_calendar-event-select'">
                  <terra-icon icon="calendar" size="20" />
                  {{ eventPickerLabel() }}
                </ninety-button>
              }
              <ng-content />
            }
          </div>
        }
      </div>
    } @else {
      <div class="meeting-agent-section meeting-agent-upsell">
        <div class="meeting-agent-intro">
          <terra-icon class="meeting-agent-intro-icon" icon="sparkle" variant="fill" size="20" />
          <div class="meeting-agent-intro-copy">
            <p class="text-light meeting-agent-upsell-text">
              Maz is available on Thrive tier. It joins your call to transcribe your meeting.
            </p>
            <ninety-button
              compact
              primary
              (click)="openPricingPlansModal()"
              [attr.data-cy]="dataCyPrefix() + '_see-plans-link'">
              See plans
            </ninety-button>
          </div>
        </div>
      </div>
    }
  </div>
}
